import Button from "components/Button/Button"
import { ModalTemplate } from "components/ModalTemplate"
import styled from "styled-components"

export const ReservationModalContainer = styled(ModalTemplate)`
`

export const ReservationModalContent = styled.div`
  margin: 0 0 25px 0;
`

export const ReservationModalDes = styled.p``

export const ReservationModalFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
`
export const ReservationModalButton = styled(Button)`
  width: 47%;
`